import I18n from "../../I18n";
import { displayValue } from "./utils/mapperUtils";

export const mapCard = (json) => {
    const { name, username, role, blocked, organizationName, hasUpgradedAccount, lastSignInAt } =
        json;
    const upgradedAccount = hasUpgradedAccount ? hasUpgradedAccount.toString() : "false";
    const lastSignInDisplay = lastSignInAt
        ? new Date(lastSignInAt).toLocaleString()
        : I18n.translate("No login recorded");
    return [
        [{ labels: ["name"], value: displayValue(name), type: "string", basis: "20%" }],
        [{ labels: ["username"], value: displayValue(username), type: "string" }],
        [
            {
                labels: ["organizationName"],
                value: displayValue(organizationName),
                type: "string",
                basis: "20%",
            },
        ],
        [
            {
                labels: ["role"],
                value: role ? I18n.translate(`role_${role}`) : "N/A",
                type: "string",
            },
        ],
        [{ labels: ["Last Sign In"], value: displayValue(lastSignInDisplay), type: "string" }],
        [
            {
                labels: [],
                value: {
                    customComponent: "UserStatus",
                    blocked,
                },
                type: "customComponent",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["hasUpgradedAccount"],
                value: {
                    customComponent: "AccountVerified",
                    verified: upgradedAccount,
                },
                type: "customComponent",
                basis: "10%",
            },
        ],
    ];
};

const mapper = (json, card, details) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    { label: ["Full name"], align: "left", columnName: "name", sortable: true, basis: "20%" },
    { label: ["Username"], align: "left", columnName: "email", sortable: true },
    {
        label: ["Organization"],
        align: "left",
        columnName: "organizations.name",
        sortable: true,
        basis: "20%",
    },
    { label: ["Role"], align: "left", columnName: "role", sortable: true },
    { label: ["Last Sign In"], align: "left", columnName: "lastSignInAt" },
    { label: ["User Status"], align: "left", basis: "10%", type: "customComponent" },
    {
        label: ["Account Verified"],
        align: "left",
        columnName: "hasUpgradedAccount",
        basis: "10%",
        type: "customComponent",
    },
];

const userMapper = {
    map: mapper,
    header,
};

export default userMapper;
